document.addEventListener('variant:change', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  let form = event.target;
  let variant_id = variant.id;
  var customMetafields = document.querySelectorAll('.custom-metafield');
  for (var i = 0; i < customMetafields.length; i++) {
    console.log('customMetafields[i]',customMetafields[i]);
    customMetafields[i].classList.remove('cstm_selected_variant');
  }
  document.getElementById('content_variant_' + variant_id).classList.add('cstm_selected_variant')
});